import styled from 'styled-components'

import theme from '~/theme'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  position: relative;
  text-align: center;
  gap: ${theme.tokens.spacingUnit * 2}px;
`

export const Image = styled.img`
  display: block;
  width: 140px;
  margin: 0 auto;
`

export const Title = styled.p`
  font-size: 16px;
  line-height: 150%;
  margin: 0;
  padding: 0 ${theme.tokens.spacingUnit * 5}px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
`

export const Message = styled.p`
  font-size: 14px;
  line-height: 1;
  margin: 0;
  font-weight: ${({ theme }) => theme.typography.fontWeight.regular};
`
